import { render, staticRenderFns } from "./BuyingStation.vue?vue&type=template&id=5338bacf&scoped=true"
import script from "./BuyingStation.vue?vue&type=script&lang=js"
export * from "./BuyingStation.vue?vue&type=script&lang=js"
import style0 from "./BuyingStation.vue?vue&type=style&index=0&id=5338bacf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338bacf",
  null
  
)

export default component.exports